module.exports = __webpack_public_path__ + "static/media/clipboard-list-check.43c951ae.svg";